import { httpPc } from '@/utils/httpPc';

export interface PromotionListParams {
  pageNo: number;
  pageSize: number;
  name: string;
  start_date: string;
  end_date: string;
}

export interface PromotionItem {
  client_type: string;
  company_id: string;
  create_time: string;
  desc: string;
  discount_sub_type: string;
  discount_type: string;
  end_date: string;
  end_time: string;
  goods_type: string;
  img: string;
  is_day_loop: string;
  max_discount: string;
  max_loop: string;
  name: string;
  promotion_id: string;
  promotion_type: string;
  putaway: string;
  is_dsortay_loop: string;
  split_type: string;
  start_date: string;
  start_time: string;
  status: string;
  update_time: string;
  sort: string;
  activeTime: string;
}

export interface PromotionListResp {
  count: number;
  list: Array<PromotionItem>,
  page_index: number;
  page_size: string;
}

export const PromotionWay = {
  SingleItemFull: '10', // 单品满件促销
  MultipleItemFull: "11", // 多品满件促销
  SingleQuotaFull: "20", // 单品满额促销
  MultipleQuotaFull: "21", // 多品满额促销
}

export const PromotionWayMap = {
  [PromotionWay.SingleItemFull]: '单品满件促销',
  [PromotionWay.MultipleItemFull]: '多品满件促销',
  [PromotionWay.SingleQuotaFull]: '单品满额促销',
  [PromotionWay.MultipleQuotaFull]: '多品满额促销',
}

export const activeStatus = {
  notStart: "1",
  underWay: "2",
  end: "3"
}

export const activeStatusMap = {
  [activeStatus.notStart]: '未开始',
  [activeStatus.underWay]: '进行中',
  [activeStatus.end]: '已结束'
};



export const getPromotionList = async (params: PromotionListParams) => {
  let res = await httpPc.get<AxiosHttpPromise<PromotionListResp>>('/RestfulApi/promotion', { params });
  return res
};

export const getPromotionDetail = async (params: {id: string}) => {
  return await httpPc.get<AxiosHttpPromise<PromotionItem>>(`/RestfulApi/promotion/${params.id}`);
}